import styled from "styled-components";
import { Box, Flex, Text } from "rebass/styled-components";
import { Link } from "react-router-dom";

export const WidgetContainer = styled(Flex)`
  align-items: stretch;
  background-image: url("${process.env
    .REACT_APP_S3_CLIP_BUCKET}/static/web/top5/top5bg2.png");
  background-position: center;
  background-repeat: repeat;
  background-size: 100%;
  border-radius: 12px;
  gap: 16px;
  height: 360px;
  justify-content: space-evenly;
  padding: 24px;
  position: relative;
  width: 100%;

  &::before {
    background: rgba(0, 0, 0, 0.4);
    border-radius: 12px;
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
  }

  @media (max-width: 1620px) and (min-width: 1321px) {
    height: 360px;
    padding: 20px;
  }

  @media (max-width: 1320px) and (min-width: 769px) {
    background-image: url("${process.env
      .REACT_APP_S3_CLIP_BUCKET}/static/web/top5/top5bgV.png");
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
    height: auto;
    padding: 16px;
  }

  @media (max-width: 768px) {
    background-image: url("${process.env
      .REACT_APP_S3_CLIP_BUCKET}/static/web/top5/top5bgV.png");
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
    height: auto;
    padding: 16px;
  }
`;

export const ClipSection = styled(Box)`
  align-items: center;
  display: flex;
  flex: 0 0 auto;

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }
`;

export const PlayersList = styled(Box)`
  display: flex;
  flex: 0 0 400px;
  flex-direction: column;
  height: 100%;
  justify-content: space-around;
  min-width: 200px;

  @media (max-width: 1620px) and (min-width: 1321px) {
    flex: 0 0 320px;
    justify-content: space-between;
  }

  @media (max-width: 768px) {
    flex: 1;
    width: 100%;
  }
`;

export const PlayerItem = styled(Flex)<{ isFirst?: boolean }>`
  align-items: center;
  border-bottom: ${({ isFirst, theme }) =>
    isFirst ? `1px solid ${theme.colors.navy50}` : "none"};
  gap: 12px;
  padding: 8px 0;

  @media (max-width: 1620px) and (min-width: 1321px) {
    gap: 8px;
    padding: 6px 0;
  }
`;

export const PlayerRank = styled(Text)<{ rank: number }>`
  color: ${({ rank, theme }) =>
    rank === 1 ? theme.colors.error : theme.colors.envy};
  font-size: ${({ rank }) => (rank === 1 ? "24px" : "18px")};
  font-weight: 800;
  min-width: 24px;
`;

export const PlayerInfo = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2px;
`;

export const PlayerName = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 14px;
  font-weight: 600;
`;

export const LogoSection = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 24px;

  img {
    height: auto;
    width: clamp(200px, 15vw, 400px);
  }

  @media (max-width: 1620px) and (min-width: 769px) {
    display: none;
  }

  @media (max-width: 768px) {
    gap: 16px;
    justify-content: center;
    margin-bottom: 16px;
    margin-right: 0;

    img {
      width: clamp(180px, 50vw, 256px);
    }
  }
`;

export const ViewNowButton = styled(Link)`
  background-color: ${({ theme }) => theme.colors.envy};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.ice};
  display: block;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 24px;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.2s ease;
  width: 200px;

  &:hover {
    background-color: ${({ theme }) =>
      theme.colors.envyDark || theme.colors.envy};
    color: ${({ theme }) => theme.colors.ice};
    text-decoration: none;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ClipPlayerContainer = styled(Box)`
  aspect-ratio: 16/9;
  border-radius: 9px;
  cursor: pointer;
  height: 100%;
  max-height: 312px;
  overflow: hidden;
  position: relative;
  width: auto;

  @media (max-width: 1620px) and (min-width: 1321px) {
    max-height: 312px;
  }

  @media (max-width: 1320px) and (min-width: 769px) {
    height: auto;
    max-height: none;
    width: 100%;
  }

  @media (max-width: 768px) {
    height: auto;
    width: 100%;
  }
`;

export const CustomFollowButton = styled(Box)`
  button {
    border-radius: 20px !important;
    font-size: 12px !important;
    height: 28px !important;
    min-width: 80px !important;
    padding: 0 12px !important;

    > svg {
      display: none !important;
    }

    gap: 0 !important;
  }
`;
